﻿import DotNetObject = DotNet.DotNetObject;
import { WebReport } from '@crimsontide/core/client/interfaces';

export const WebReportService = (() => {
  let dotNetObj: DotNetObject;

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getJobCompletionReports = async (): Promise<WebReport[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<WebReport[]>('GetJobCompletionWebReportsAsync');
    } else {
      throw 'WebReport DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getJobCompletionReports,
  };
})();
